<!-- Sobreposição de edição inline -->
<div 
  class="inline-editor-overlay" 
  *ngIf="showInlineEditor"
  [style.left.px]="editorPosition.x"
  [style.top.px]="editorPosition.y"
  [style.width.px]="editorPosition.width"
  (keydown)="onKeyDown($event)">
  
  <nz-card 
    nzSize="small" 
    class="inline-editor-card"
    #editorCard
    [nzTitle]="cardTitle"
    [nzExtra]="cardExtra">
    
    <!-- Template do Título do Card -->
    <ng-template #cardTitle>
      <div class="card-title">
        <nz-icon nzType="edit" nzTheme="outline"></nz-icon>
        <span>{{ 'builderScreen.inlineEditor.title' | translateTA }}</span>
        <nz-tag *ngIf="currentComponent" [nzColor]="'blue'" nzSize="small">
          {{ currentComponent.type | titlecase }}
        </nz-tag>
      </div>
    </ng-template>

    <!-- Template Extra do Card -->
    <ng-template #cardExtra>
      <div class="card-actions">
        <button 
          nz-button 
          nzType="text" 
          nzSize="small"
          [nz-tooltip]="'builderScreen.inlineEditor.tooltip.close' | translateTA"
          (click)="closeInlineEditor()">
          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
        </button>
      </div>
    </ng-template>

    <!-- Propriedades Rápidas -->
    <div class="quick-properties">
              <div 
          *ngFor="let property of quickEditProperties; let i = index; trackBy: trackByProperty"
          class="property-item">
        
        <!-- Campo de Texto -->
        <div *ngIf="property.type === 'text'" class="property-control">
          <label>{{ property.displayName }}</label>
          <input 
            nz-input 
            nzSize="small"
            [value]="property.value"
            (input)="updatePropertyInline(property, $event.target.value)"
            [placeholder]="'Enter ' + property.displayName.toLowerCase()">
        </div>

        <!-- Campo Numérico -->
        <div *ngIf="property.type === 'number'" class="property-control">
          <label>{{ property.displayName }}</label>
          <nz-input-number
            nzSize="small"
            [nzValue]="property.value"
            (nzValueChange)="updatePropertyInline(property, $event)"
            style="width: 100%">
          </nz-input-number>
        </div>

        <!-- Switch Booleano -->
        <div *ngIf="property.type === 'boolean'" class="property-control">
          <label>{{ property.displayName }}</label>
          <nz-switch
            nzSize="small"
            [ngModel]="property.value"
            (ngModelChange)="updatePropertyInline(property, $event)">
          </nz-switch>
        </div>

        <!-- Dropdown de Seleção -->
        <div *ngIf="property.type === 'select'" class="property-control">
          <label>{{ property.displayName }}</label>
          <nz-select
            nzSize="small"
            [ngModel]="property.value"
            (ngModelChange)="updatePropertyInline(property, $event)"
            style="width: 100%">
            <nz-option
              *ngFor="let option of property.options"
              [nzValue]="option.value"
              [nzLabel]="option.label">
            </nz-option>
          </nz-select>
        </div>

        <!-- Seletor de Cor -->
        <div *ngIf="property.type === 'color'" class="property-control">
          <label>{{ property.displayName }}</label>
          <div class="color-input-group">
            <nz-color-picker
              nzSize="small"
              [ngModel]="property.value"
              (ngModelChange)="updatePropertyInline(property, $event)"
              nzShowText>
            </nz-color-picker>
            <div 
              class="color-preview"
              [style.background-color]="property.value">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Ações Inline -->
    <div class="inline-actions">
      <button 
        nz-button 
        nzType="link" 
        nzSize="small"
        (click)="openFullEditor()"
        class="full-editor-btn">
        <nz-icon nzType="setting" nzTheme="outline"></nz-icon>
        {{ 'builderScreen.inlineEditor.button.moreOptions' | translateTA }}
      </button>
      
      <div class="keyboard-hint">
        <small>
          <nz-icon nzType="enter" nzTheme="outline"></nz-icon>
          {{ 'builderScreen.inlineEditor.hint.ctrlEnter' | translateTA }}
        </small>
      </div>
    </div>
  </nz-card>
</div>
